<script setup>
import { computed } from "vue";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  updatedPageNumber: {
    type: Function,
    required: true,
  },
});

// Filter valid links
const validLinks = computed(() => {
  if (!props.data?.meta?.links) return [];
  return props.data.meta.links.filter((link) => link && link.label);
});
</script>

<template>
  <div class="py-6 mx-auto max-w-7xl">
    <div class="mx-auto max-w-none">
      <div class="overflow-hidden bg-white shadow sm:rounded-lg">
        <div
          class="flex flex-col items-center justify-between px-4 py-3 bg-white border-t border-gray-200 sm:flex-row sm:px-6"
        >
          <div class="mb-4 sm:mb-0">
            <p class="text-sm text-gray-700" v-if="data?.meta">
              Showing
              <span class="font-medium">{{ data.meta.from || 0 }}</span>
              to
              <span class="font-medium">{{ data.meta.to || 0 }}</span>
              of
              <span class="font-medium">{{ data.meta.total || 0 }}</span>
              results
            </p>
            <p class="text-sm text-gray-700" v-else>
              No pagination data available
            </p>
          </div>
          <div class="pagination">
            <nav
              class="relative z-0 inline-flex -space-x-px rounded-md shadow-sm"
              aria-label="Pagination"
            >
              <button
                @click.prevent="updatedPageNumber(link)"
                v-for="(link, index) in validLinks"
                :key="index"
                :disabled="link.active || !link.url"
                class="relative inline-flex items-center px-2 py-2 text-sm font-medium border sm:px-4"
                :class="{
                  'z-10 bg-indigo-50 border-indigo-500 text-indigo-600':
                    link.active,
                  'bg-white border-gray-300 text-gray-500 hover:bg-gray-50':
                    !link.active,
                }"
              >
                <span v-html="link.label || ''"></span>
              </button>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media (max-width: 640px) {
  .pagination button {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }
}
</style>
